import React, { useState } from "react";
import { Eye, EyeOff, LockKeyhole, UserRound } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./../styles/Login.css";
const STATIC_USERNAME = "naturalpackers@gmail.com";
const STATIC_PASSWORD = "12345678";
export default function Login() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");
        if (!username.trim() || !password.trim()) {
            setError("Please enter username and password");
            return;
        }
        setLoading(true);
        setTimeout(() => {
            if (
                username.trim() === STATIC_USERNAME &&
                password === STATIC_PASSWORD
            ) {
                sessionStorage.setItem("backofficeAuth", "true");
                navigate("/backoffice/dashboard", { replace: true, });
            } else {
                setError("Invalid username or password");
            }
            setLoading(false);
        }, 500);
    };
    return (
        <div className="backoffice-login">
            <div className="login-container">
                <div className="login-brand-section">
                    <div className="brand-content">
                        <div className="brand-logo">NP</div>
                        <h1>Natural Packers<br /><span>& Movers</span></h1>
                        <p>Manage your moving enquiries, quotations,customers and services from one place.</p>
                        <div className="brand-line"></div>
                        <span className="brand-label">BACKOFFICE</span>
                    </div>
                </div>
                <div className="login-form-section">
                    <div className="login-form-container">
                        <div className="login-mobile-logo">NP</div>
                        <div className="login-heading">
                            <h2>Welcome Back</h2>
                            <p>Sign in to access your backoffice</p>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="username">Username</label>
                                <div className="input-wrapper">
                                    <UserRound size={19} />
                                    <input id="username" type="text" placeholder="Enter username" value={username}
                                        onChange={(e) => { setUsername(e.target.value); setError(""); }} autoComplete="username" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <div className="input-wrapper">
                                    <LockKeyhole size={19} />
                                    <input id="password" type={showPassword ? "text" : "password"} placeholder="Enter password" value={password}
                                        onChange={(e) => { setPassword(e.target.value); setError(""); }} autoComplete="current-password" />
                                    <button type="button" className="password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}>{showPassword ? (<EyeOff size={18} />) : (<Eye size={18} />)}
                                    </button>
                                </div>
                            </div>
                            {error && (<div className="login-error">{error}</div>)}
                            <button type="submit" className="login-button" disabled={loading}>{loading ? "Signing in..." : "Sign In"}</button>
                        </form>
                        <div className="login-footer">
                            <span>Praneesh Infotech - Version 1.0</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}